export default __webpack_public_path__ + "static/media/epl-banner-ms.c8050c6f.jpg";